'use client'

import { type ReactNode, createContext, useContext, useEffect, useState } from 'react'

interface SidebarContextType {
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  toggleCollapsed: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

const SIDEBAR_KEY = 'RTSC_LEFT_SIDEBAR_COLLAPSED'

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsedState] = useState(false)

  // Load initial state from localStorage
  useEffect(() => {
    const stored = localStorage.getItem(SIDEBAR_KEY)
    if (stored) {
      setCollapsedState(JSON.parse(stored))
    }
  }, [])

  const setCollapsed = (newCollapsed: boolean) => {
    setCollapsedState(newCollapsed)
    localStorage.setItem(SIDEBAR_KEY, JSON.stringify(newCollapsed))
  }

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed, toggleCollapsed }}>{children}</SidebarContext.Provider>
  )
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}
